export const GET_PAGERDUTY_SERVICES = "GET_PAGERDUTY_SERVICES";
export const GET_PAGERDUTY_SERVICES_SUCCESS = "GET_PAGERDUTY_SERVICES_SUCCESS";
export const GET_PAGERDUTY_SERVICES_FAIL = "GET_PAGERDUTY_SERVICES_FAIL";
export const UPDATE_PAGERDUTY_BLUEJAY_TEAM = "UPDATE_PAGERDUTY_BLUEJAY_TEAM";
export const UPDATE_PAGERDUTY_BLUEJAY_TEAM_SUCCESS = "UPDATE_PAGERDUTY_BLUEJAY_TEAM_SUCCESS";
export const UPDATE_PAGERDUTY_BLUEJAY_TEAM_FAIL = "UPDATE_PAGERDUTY_BLUEJAY_TEAM_FAIL";

export const GET_REFRESH_PAGERDUTY = "GET_REFRESH_PAGERDUTY";
export const GET_REFRESH_PAGERDUTY_SUCCESS = "GET_REFRESH_PAGERDUTY_SUCCESS";
export const GET_REFRESH_PAGERDUTY_FAIL = "GET_REFRESH_PAGERDUTY_FAIL";